import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { DeleteOutlined, EditOutlined, EyeOutlined, IeOutlined, MessageOutlined } from '@ant-design/icons';
import { Modal, Divider, Card, Pagination, Row, Drawer, List, Avatar, Space } from 'antd';
import PageTitle from '@/components/PageTitle';
import { Form } from '@ant-design/compatible';
import TableActionBar from '@/components/TableActionBar';
import qs from 'qs';
import GuideForm from './GuideForm';
import { checkPermission } from '@/utils/permission';
import { cleanObject, processHTML, stripHtml } from '@/utils/helpers';
import TextTruncate from 'react-text-truncate';
import ReactHtmlParser from 'react-html-parser';
import avatar from '@/assets/img/favicon.png';
import "react-quill/dist/quill.core.css";
import { isMobile } from 'react-device-detect';
import moment from 'moment';
import CommentsComponent from '@/components/CommentsComponent';
import { getAllGuide, getGuide, removeGuide } from '@/redux/actions/GuideActions';

const { confirm } = Modal;

const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/guide',
        breadcrumbName: 'Hướng dẫn sử dụng',
    },
]

class GuideList extends Component {

    state = {
        isLoading: false, // loading table
        isOpenForm: false,
        currentData: null,
        openView: false,
    }

    componentDidMount() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.setState({ isLoading: true });
        this.props.getAllGuide(query).then(() => {
            this.setState({ isLoading: false });
        })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.setState({ isLoading: true });
            this.props.getAllGuide(query).then(() => {
                this.setState({
                    isLoading: false
                })
            })
        }
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }
        query = cleanObject(query);
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        });
    }

    toggleOpenForm(isOpenForm, data = null) {
        this.setState({ isOpenForm: isOpenForm, currentData: data });
    }

    onEdit(id) {
        this.props.getGuide(id).then(res => {
            this.toggleOpenForm(true, res);
        })
    }

    onView(id) {
        this.props.getGuide(id).then(res => {
            this.setState({ openView: true, currentData: res });
        })
    }

    openAlert(id) {
        confirm({
            title: 'Cảnh báo',
            content: 'Bạn chắc chắn muốn xoá bản ghi này?',
            okText: 'OK',
            cancelText: 'Huỷ',
            onOk: () => this.props.removeGuide([id]).then(() => {
                this.reloadData()
                setTimeout(() => {
                    Modal.destroyAll();
                }, 800);
            }),
            onCancel() { },
        })
    }

    reloadData() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.setState({ isLoading: true });
        this.props.getAllGuide(query).then(() => {
            this.setState({ isLoading: false });
        })
    }

    loadData() {
        this.props.form.resetFields();
        this.props.getGuide(this.state.currentData.id).then(res => {
            this.setState({ currentData: res, submitting: false, });
        })
    }

    render() {
        var { guide, pagination } = this.props;
        var { isLoading, isOpenForm, openView, currentData } = this.state;
        var query = qs.parse(this.props.location.search.slice(1));

        const IconText = ({ icon, text }) => (
            <Space>
                <span style={{ cursor: 'pointer' }}>
                    {React.createElement(icon)}&nbsp;
                    {text}
                </span>
            </Space>
        );

        return (
            <div>
                <PageTitle routes={routes} title="Hướng dẫn sử dụng" />
                <div>
                    <TableActionBar
                        isShowAddButton={checkPermission('guide', 'create')}
                        isShowDeleteButton={false}
                        onAdd={() => this.toggleOpenForm(true)}
                        showFilter={false}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                    >
                    </TableActionBar>
                </div>
                <Card>
                    <List
                        itemLayout="vertical"
                        loading={isLoading}
                        rowKey='id'
                        size="large"
                        dataSource={guide}
                        renderItem={item => {
                            const IconAction = [
                                <IconText icon={MessageOutlined} text={item.countComment || 0} key="list-vertical-message" />
                            ];
                            IconAction.push(<a onClick={() => this.onView(item.id)} key="list-vertical-view-on-pages"><EyeOutlined /> Xem nhanh</a>)
                            IconAction.push(<Link to={`/guide/${item.id}`} key="list-vertical-detail"><IeOutlined /> Xem chi tiết</Link>)

                            if (checkPermission('guide', 'update')) {
                                IconAction.push(<a onClick={() => this.onEdit(item.id)} type='link' key="list-vertical-edit"><EditOutlined /> Chỉnh sửa</a>)
                            }
                            if (checkPermission('guide', 'remove')) {
                                IconAction.push(<a onClick={() => this.openAlert(item.id)} type='link' key="list-vertical-delete"><DeleteOutlined /> Xóa</a>)
                            }
                            return (
                                <List.Item
                                    key={item.title}
                                    actions={IconAction}
                                >
                                    <List.Item.Meta
                                        avatar={<Avatar src={avatar} />}
                                        title={item.title}
                                        description={
                                            <>
                                                <div>{moment(item.created_at).format('DD/MM/YYYY')} by: {item.created_user}</div>
                                            </>
                                        }
                                    />
                                    <TextTruncate line={3} truncateText="…" text={stripHtml(item.content)} />
                                </List.Item>
                            )
                        }
                        }
                    />
                    < Row justify="end" >
                        <Pagination {...pagination} onChange={(page) => this.onChangeFilter('page', page)} />
                    </Row >
                </Card >
                <GuideForm
                    visible={isOpenForm}
                    currentData={currentData}
                    reloadData={() => this.reloadData()}
                    onCancel={() => this.toggleOpenForm(false)}
                />

                <Drawer
                    visible={openView}
                    title={currentData ? currentData?.title : 'CHI TIẾT'}
                    onClose={() => this.setState({ openView: false })}
                    maskClosable={true}
                    width={isMobile ? '100%' : '70%'}
                >
                    {
                        openView ?
                            <div>
                                {
                                    currentData ? (
                                        <>
                                            <div className="view ql-editor training-img chingo-content-detail">
                                                {ReactHtmlParser(processHTML(currentData?.content))}
                                            </div>
                                            <Divider />
                                            <CommentsComponent
                                                reloadData={() => this.loadData()}
                                                commentsData={currentData.comments}
                                                type="guide"
                                                parentId={currentData?.id}
                                            />
                                        </>
                                    ) : null
                                }
                            </div>
                            : null
                    }
                </Drawer>
            </div >
        )
    }
}

function mapStateToProps(state) {
    return {
        guide: state.Guide.guide,
        pagination: state.Guide.pagination,
        authUser: state.auth.authUser
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getAllGuide: (filter) => dispatch(getAllGuide(filter)),
        getGuide: (id) => dispatch(getGuide(id)),
        removeGuide: (ids) => dispatch(removeGuide(ids)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'GuideList' })(GuideList));
